<template>
  <div :class="['select-photo-wrap', `${page_style}`]" v-if="formItem.type === 'select-photo'">
    <template v-if="selectConfig.banner">
      <div class="title" v-html="selectConfig.banner.title"></div>
      <div class="desc" v-html="selectConfig.banner.desc"></div>
    </template>
    <div class="radio" v-if="radio.list.length">
      <div v-for="(item, i) in radio.list" :class="['radio-item', {'is-selected': selectValue === item.value}]" :key="i" @click="changeSelect(item)">
        <img-v3 class="exam-img" :src="item.example_pic_url" alt="" v-if="item.example_pic_url" />
        <div class="radio-info">
          <p class="radio-title">{{item.title}}</p>
          <p class="radio-desc">{{item.pic_desc}}</p>
          <p :class="['radio-result', {'failed': formItem.field_status === 5}]" v-if="formItem.field_result && radio.value === item.value">{{formItem.field_result}}</p>
        </div>
        <img-v3 v-if="item.icon_url" class="radio-icon" :src="selectValue === item.value ? item.select_icon_url : item.icon_url" />
      </div>
    </div>
    <div class="bottom" v-if="selectConfig.button && !isFleetFunnel">
      <div class="next-btn" :style="buttonStyle" @click="go">{{selectValue ? checkedButtonColor.title : buttonColor.title}}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import { post } from "../../../tools/request";
import { SUPPORT_COUNTRY as sc, ends } from "../../../tools/constant";

export default {
  //cm means commit
  //linked_val,是否受其他组件控制，与linked配合使用
  data() {
    return {
      selectValue: '',
      goRouter: '',
      backConfig: {},
      skipRouter: null,
    }
  },
  props: [
    "auditConfig",
    "idx",
    "is_ocr",
    "dialogStyle",
    "page_type",
    "is_finished",
    "canUpload",
  ],
  computed: {
    ...mapState(["_ticket"]),
    inApp() {
      return !!Fusion.pickImage;
    },
    country() {
      //notes set default country
      let c = new URLSearchParams(location.search).get("location_country");
      return sc[c] || "Mx";
    },
    //传递过来整个对象
    formItem() {
      let c = this.isFleetPCFunnel ? this.auditConfig : this.$route.params.configs ;
      return c || this.backConfig;
    },
    page_style() {
      return this.$route.params.page_style || this.dialogStyle;
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    selectConfig() {
      return this.formItem.select || {};
    },
    radio() {
      return this.selectConfig.radio || {};
    },
    bottom() {
      return this.selectConfig.button || {};
    },
    buttonColor(){
      return (this.bottom.button_color || {}).un_check || {}
    },
    checkedButtonColor(){
      return (this.bottom.button_color || {}).is_check || {}
    },
    buttonStyle() {
      return{
          color: this.selectValue ? this.checkedButtonColor.text_color : this.buttonColor.text_color,
          background: this.selectValue ? this.checkedButtonColor.background_color : this.buttonColor.background_color
      }
    },
    isNew() {
      return this.formItem.field_status == 0;
    },
    isFailed() {
      return this.formItem.field_status == 5;
    },
    isIng() {
      return this.formItem.field_status == 3;
    },
    isSuccess() {
      return this.formItem.field_status == 4;
    },
    preValue() {
      return this.radio.value || this.formItem.value || ''; // @200914 radio.value兼容巴西老数据(先找radio里有没有key、value,没有再找最外层)
    },
  },
  mounted() {

  },
  created() {
    this.selectValue = this.preValue || '';
    this.goRouter = ((this.radio.list || []).find(item => item.value === this.selectValue) || {})['tip'];
    if (this.formItem.business_type === 'br_pop_crlv_pdf') {
      // 默认跳转的组件value
      let business_value = this.formItem.business_value || '';
      let skipRouter = (this.formItem.pic_desc[business_value] || {}).type;
      let select_value = ((this.radio.list || []).find(item => item.tip === this.formItem.business_value) || {})['value']
      if (this.inApp) {
        if (!Fusion.chooseFile) {
          this.selectValue = select_value;
          this.goRouter = business_value;
          this.skipRouter = skipRouter;
          this.go();
          return
        }
      } else {
        // console.log(ends)
        if (ends.isIOS) {
          this.selectValue = select_value
          this.goRouter = business_value;
          this.skipRouter = skipRouter;
          this.go();
          return
        }
      }
    }
    // @200918, 审核态也可以重新进入选择页重新上传
    if (this.isSuccess) {
      this.go();
    }
  },
  watch: {

  },
  methods: {
    changeSelect(item) {
      this.selectValue = item.value;
      this.goRouter = item.tip;
      if (this.isFleetFunnel) {
        this.go();
      }
    },
    go() {
      let goRouter = (this.formItem.pic_desc[this.goRouter] || {}).type;

      if (this.skipRouter) {
        goRouter = this.skipRouter;
      }

      const rou = {
        'photo': `upload${this.country}`,
        'in_select_photo': `detailMultiUpload`,
        'photo_pdf': `uploadPdf${this.country}`,
        'photo_new': `uploadNew`,
        'photo_pdf_new': `uploadNew`,
        "multi-photo": `multiUpload${this.country}`,
      }[goRouter];

      const params = {
        configs: {
            ...this.formItem.pic_desc[this.goRouter],
            job_type: this.formItem.job_type,
            job_uid: this.formItem.job_uid,
            field_status: this.selectValue === this.preValue ? this.formItem.field_status : 0,
            field_result: this.selectValue === this.preValue ? this.formItem.field_result : '',
            radio_type_key: this.radio.key || this.formItem.key, // @200903 radio选择类型透传 // @200914 radio.key兼容巴西老数据
            radio_type_value: this.selectValue,
            document_enum: this.formItem.document_enum,
            limit_status: this.formItem.limit_status
            // key: this.formItem.key,
            // value: this.selectValue,
          },
          page_style: this.page_style,
      }
      if (this.isFleetPCFunnel) {
        this.$emit('setAuditConfig', params.configs)
      } else {
        this.$router.replace({
          name: rou,
          params: {
            ...params,
            page_route: this.$route.params.page_route
          }
        });
      }


    },

  }
};
</script>
<style lang="scss" scoped>
.select-photo-wrap {
  // height: 100%;
  padding: 0.6rem 0.32rem 2rem;
  box-sizing: border-box;
  .title {
    // margin-top: 0.6rem;
    font-weight: 500;
    font-size: 0.48rem;
    color: #0F1928;
  }
  .desc {
    margin-top: 0.24rem;
    line-height: 0.36rem;
    font-size: 0.28rem;
    color: #0F1928;
    opacity: 0.8;
  }
  .radio {
    margin-top: 0.4rem;
  }
  .radio-item {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 2rem;
    // height: 2rem;
    width: 100%;
    padding: 0.4rem 0.32rem;
    margin-top: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.12rem;
    border: 1px solid transparent;
    &.is-selected {
      background: #F4FAFF;
      border: 1px solid #2697FF;
    }
    &:first-of-type {
      margin-top: 0;
    }
    .exam-img {
      width: .88rem;
      height: .88rem;
      margin-right: .2rem;
    }
    .radio-info {
      width: 5.16rem;
      padding-right: .36rem;
    }
    .radio-title {
      line-height: 0.48rem;
      font-weight: 500;
      font-size: 0.36rem;
      color: #0F1928;
    }
    .radio-desc {
      margin-top: 0.08rem;
      font-size: 0.28rem;
      color: #97989A;
    }
    .radio-result {
      margin-top: 0.1rem;
      font-size: 0.28rem;
      &.failed {
        color: #FF525D;
      }
    }
    .radio-icon {
      position: absolute;
      right: 0.32rem;
      width: 0.36rem;
      height: 0.36rem;
    }
  }
  .bottom {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    .next-btn{
      height: 1.08rem;
      line-height: 1.08rem;
      text-align: center;
      font-size: 0.36rem;
      font-weight: 500;
    }
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    padding-top: 0.4rem;
    box-sizing: border-box;
    min-height: 100vh;
    background: #ffffff;
    .title {
      line-height: 0.48rem;
      font-size: .4rem;
      color: #333333;
      font-weight: 700;
    }
    .radio-item {
      padding: 0;
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #EEEEEE;
      &.is-selected {
        background: none;
        border: none;
      }
      .exam-img {
        width: .96rem;
        height: auto;
        margin-right: .24rem;
      }
      .radio-title {
        font-size: .32rem;
        color: #333333;
        font-weight: 700;
      }
      .radio-icon {
        right: 0;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  &.h5_funnel_fleet_pc {
    min-height: auto;
    padding: 40px 0 0 0;
    .title {
      font-size: 20px;
      line-height: 24px;
    }
    .desc {
      margin-top: 12px;
      font-size: 14px;
      line-height: 16px;
    }
    .radio {
      margin-top: 20px;
    }
    .radio-item {
      min-height: 88px;
      .exam-img {
        width: 48px;
        margin-right: 12px;
      }
      .radio-title {
        line-height: 20px;
        font-size: 16px;
      }
      .radio-desc {
        margin-top: 5px;
        line-height: 16px;
        font-size: 14px;
      }
      .radio-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
}

</style>
